
export const stateValues = ["AL","AR","AZ","CA","CO","CT","DC","DE","FL","GA","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VA","VT","WA","WI","WV","WY"];

// export const stateValuesFallHeight = {
//   "AL": "12in",
//   "AR": "6in",
//   "AZ": "6in",
//   "CA": "12in",
//   "CO": "9in",
//   "CT": "12in",
//   "DC": "12in",
//   "DE": "9in",
//   "FL": "12in",
//   "GA": "3ft- 3in",
//   "IA": "12in",
//   "ID": "12in",
//   "IL": "12in",
//   "IN": "9in",
//   "KS": "12in",
//   "KY": "12in",
//   "LA": "8-12in",
//   "MA": "12in",
//   "MD": "12in",
//   "ME": "12in",
//   "MI": "12in",
//   "MN": "12in",
//   "MO": "12in",
//   "MS": "12in",
//   "MT": "6in",
//   "NC": "5-7ft-6in over 9in",
//   "ND": "12in",
//   "NE": "12in",
//   "NH": "12in",
//   "NJ": "12in",
//   "NM": "12in",
//   "NV": "12in",
//   "NY": "6min (9rec)",
//   "OH": "9in",
//   "OK": "6-9in",
//   "OR": "9in",
//   "PA": "12in",
//   "RI": "12in",
//   "SC": "12in",
//   "SD": "12in",
//   "TN": "12in",
//   "TX": "9in",
//   "UT": "12in",
//   "VA": "12in",
//   "VT": "12in",
//   "WA": "6in",
//   "WI": "9in",
//   "WV": "12in",
//   "WY": "7ft-6in 10ft-9in"
// };

export const budgetValues = [
  "Under $5,000",
  "$5,000 to $10,000",
  "$10,000 to $15,000",
  "$15,000 to $20,000",
  "$20,000 to $30,000",
  "$30,000 to $50,000",
  "$50,000 to $100,000",
  "$100,000 to $200,000",
  "Over $200,000",
  "I haven't established a budget"
];

export const buyingForValues = [
  "Daycare or Preschool",
  "Public School",
  "Private School",
  "Governmental Entity (Parks Dept, Public Works, etc.)",
  "Church or Place of Worship",
  "YMCA, JCC, or Other Community Center",
  "Campground, Summer Camp, etc.",
  "Country/Golf Club",
  "Construction or Landscaping company",
  "Homeowners Association",
  "Management Company",
  "Private Home",
  "Non-profit (Headstart, Hospital, etc.)",
  "For-profit Business (Restaurants, Car Wash, etc.)",
  "Other (Please Specify)"
];

export const lookingForValues = [
  "The best equipment for my approved budget",
  "The right equipment for my organization",
  "Pricing to take to our decision maker(s)"
];

export const specialRequestsValues = [
  "I need suggestions for building a new playground from scratch",
  "I need suggestions for shade structures and options",
  // "I added lots of playgrounds to my quote, but I am only looking for one",
  "I would like to pay with ClassWallet (a 2.5% charge will be applied to your order and cannot be used with a purchase order)"
];

export const placeOrderValues = [
  "ASAP",
  "In the coming weeks",
  "In the coming months",
  "3 to 6 months from now",
  "Within the year",
  "I don't know, mainly gathering information"
];

export const buildingCodeValues = [
  "IBC 2021 – International Building Code 2021",
  "IBC 2018 – International Building Code 2018",
  "IBC 2015 – International Building Code 2015",
  "IBC 2012 – International Building Code 2012",
  "IBC 2009 – International Building Code 2009",
  "IBC 2006 – International Building Code 2006",
  "IBC 2003 – International Building Code 2003",
  "IBC 2000 – International Building Code 2000",
  "DSA – Division of the State Architect",
  "CBC 2022 – CA Building Code 2022 (based on IBC 2021)",
  "CBC 2019 – CA Building Code 2020 (based on IBC 2018)",
  "CBC 2016 – CA Building Code 2016 (based on IBC 2015)",
  "CBC 2013 – CA Building Code 2013 (based on IBC 2012)",
  "CBC 2010 – CA Building Code 2010 (based on IBC 2009)",
  "FBC 2020 – FL Building Code 2020 (based on IBC 2018)",
  "FBC 2017 – FL Building Code 2017 (based on IBC 2015)",
  "FBC 2014 – FL Building Code 2014 (based on IBC 2012)",
  "FBC 2010 – FL Building Code 2010 (based on IBC 2009)",
  "Other or I don't know...",
];

export const surfaceTypeOptions = [
  "Rubber Mulch", 
  "Engineered Wood Fiber", 
  "Pour in Place Surfacing", 
  "Artificial Turf",
];

/** Product handle → value in surfaceTypeOptions when that product is on the quote */
export const surfacingProductHandleToType = {
  "turf-playground-surfacing": "Artificial Turf",
  "playground-rubber-mulch": "Rubber Mulch",
  "pour-in-place-playground-surfacing-fully-installed": "Pour in Place Surfacing",
  "engineered-wood-fiber-playground-surfacing": "Engineered Wood Fiber",
};
export const currentSurfaceTypeValues = [
  "Concrete Slab",
  "Asphalt",
  "Grass/Dirt",
  "Mulch",
  "Gravel",
  "Other"
];

export const accomodationsValues = [
  "I have a very tight and/or strict deadline",
  "I need to remove old equipment (pictures required for quoting)",
  "I am adding to an existing playground",
  "Construction equipment may have difficulty accessing my site",
  "My project will require permitting (Customer's responsibility)",
  // "NEW FEATURE: I would like an overhead layout drawing (reserved for quotes with 2 or more items)"
]

export const criticalFallHeightValues = [
  { "label": "4 feet", "value": 4},
  { "label": "5 feet", "value": 5},
  { "label": "6 feet", "value": 6},
  { "label": "7 feet", "value": 7},
  { "label": "8 feet", "value": 8},
  { "label": "9 feet", "value": 9},
  { "label": "10 feet", "value": 10},
  { "label": "12 feet", "value": 12},
];

export const FormFieldDefinitions = [
  // {name: "contact-header", type: "header", label: "Contact Information", section: "contact"},
  {name: "first_name", required: true, type: "text", label: "First Name", placeholder: "", size: "half", section: "contact", summary: true, summary_style: "primary", summary_comma: false},
  {name: "last_name", required: true, type: "text", label: "Last Name", placeholder: "", size: "half", section: "contact", summary: true, summary_style: "primary", summary_comma: true},
  {name: "company", required: false, type: "text", label: "Company or Organization", placeholder: "", size: "half", section: "contact", summary: true, summary_style: "primary", summary_comma: false},
  {name: "email", required: true, type: "email", label: "Email", placeholder: "", size: "half", section: "contact"},
  {name: "phone_number", required: true, type: "tel", label: "What’s the best phone number to reach you?", placeholder: "", size: "half", section: "contact", tooltip: "For more complex quotes, we may call to finalize details. Please list the best direct line to reach you, rather than a generic number for the whole business."},
  // {name: "phone_number", required: true, type: "tel", label: "Phone Number", placeholder: "", size: "half", section: "contact"},

  // {name: "direct_phone_number", required: true, type: "tel", label: "Direct Phone Number", placeholder: "", size: "half", section: "contact"},

  {name: "extension", required: false, type: "text", label: "Extension", placeholder: "", size: "small", section: "contact"},
  
  {name: "address_1", required: true, type: "text", label: "Shipping Address", placeholder: "", size: "half", section: "contact"},
  {name: "address_2", required: false, type: "text", label: "Shipping Address 2", placeholder: "", size: "half", section: "contact"},
  
  {name: "city", required: true, type: "text", label: "City", placeholder: "", size: "half", section: "contact", summary: true, summary_style: "secondary", summary_comma: true, summary_line_break: true},
  {name: "state", required: true, type: "select", label: "State", placeholder: "Select your state", options: stateValues, size: "small", section: "contact", summary: true, summary_style: "secondary", summary_comma: false},
  {name: "zip_code", required: true, type: "zip", label: "Zip Code", placeholder: "", pattern: 'pattern="/^\d{5}(-\d{4})?$/"', size: "small", section: "contact"},
  
  // {name: "project-header", type:"header", label: "Project Details", section: "project"},
  {name: "select_buying_for", required: true, type: "select", label: "What kind of organization best describes you?", placeholder: "Type of organization...", options: buyingForValues, size: "half", section: "project", summary: true, summary_style: "primary"},
  {name: "specific_buying_for", required: false, type: "hidden", label: "Other (Please Specify)", placeholder: "Please specify your organization", size: "half", section: "project"}, // Type is changed to 'text' if 'select_buying_for' is equal to 'Other (please specify)'
  // {name: "tax_exempt", required: false, type: "radio", label: "Tax Exempt", options: ["Yes","No"], size: "half", section: "project"},
  {name: "tax_exempt", required: false, type: "radio", label: "Is your organization tax exempt?", options: ["Yes","No"], size: "half", section: "project"},
  // {name: "tax_certificate", required: false, type: "hidden", label: "Tax Exemption Certificate", placeholder: "PDF documents only.", size: "half", section: "project"}, // Type is changed to 'file' is 'tax_exempt' is set to 'Yes'
  {name: "tax_certificate", required: false, type: "hidden", label: "Tax Exemption Certificate", placeholder: "Upload your tax exemption.", size: "half", section: "project", accept: "application/pdf,.pdf,image/jpeg,image/png,image/gif,image/webp,image/*,.jpg,.jpeg,.png,.gif,.webp", maxSizeMB: 5}, // Type is changed to 'file' is 'tax_exempt' is set to 'Yes'
  

  // {name: "site-header", type: "header", label: "Site Details"},
  // {name: "residential_commercial", required: false, type: "radio", label: "Residential or Commercial Delivery Location", options: ["Residential","Commercial"], section: "project"},  
  {name: "residential_commercial", required: false, type: "hidden", label: "Residential or Commercial", placeholder: "", size: "half", section: "project"}, // New field

  
  {name: "quote_installation", required: false, type: "radio", label: "We also offer <a href='https://willygoat.com/pages/installation-services' target='_blank'>installation services</a> for larger projects. Would you like us to quote installation for you?", options: ["Yes", "No"], size: "half", section: "project", summary: false, summary_style: "secondary", summary_comma: false, summary_line_break: true, labelIsHtml: true},
  {name: "site_dimensions", required: false, type: "hidden", label: "Site Dimensions (in feet)", size: "half", section: "project"},

  {name: "surfacing_request", required: false, type: "radio", label: "All playground equipment needs surfacing. Would you like to include that in your quote?", options: ["Yes", "No"], size: "half", section: "project"},

  {name: "surfacing_type", required: false, type: "hidden", label: "Please select the surfacing type you are interested in...", options: surfaceTypeOptions, size: "half", section: "project"},
  {name: "current_surface", required: false, type: "hidden", label: 'Current Surface Type', placeholder: "Select current surface type", size: "half", options: currentSurfaceTypeValues, section: "project" },
  {name: "critical_fall_height", required: false, type: "hidden", label: 'Critical Fall Height', placeholder: "Select Critical Fall Height of equipment", options: criticalFallHeightValues, size: "half", section: "project" },
  
  {name: "surfacing_square_footage", required: false, type: "hidden", label: "Playground Surfacing Square Footage", size: "half", section: "project"},
  // {name: "site_dimensions", required: false, type: "hidden", label: "Site Dimensions (in feet)", size: "half", section: "project"},


  {name: "accommodations", required: false, type: "hidden", label: "Any potential issues that we need to try to accommodate?", options: accomodationsValues, size: "half", section: "project"},
  {name: "removal_photos", required: false, type: "hidden", label: "Equipment Removal Photo", placeholder: "Upload a photo of the equipment to be removed.", size: "half", section: "project", accept: "image/jpeg,image/png,image/gif,image/webp,image/*,.jpg,.jpeg,.png,.gif,.webp", maxSizeMB: 10}, // Type is changed to 'file' when 'I need to remove old equipment' is in accommodations


  {name: "project_deadline", required: false, type: "hidden", label: 'Project Deadline', placeholder: "Enter Date, if applicable", size: "half", section: "project" },
  
  
  {name: "building_code", required: false, type: "select", label: "Building Code (for shade structure permitting)", placeholder: "Please select a building code...", options: buildingCodeValues, size: "half", section: "project"},
  {name: "specific_building_code", required: false, type: "hidden", label: "Other or I don't know...", placeholder: "", size: "half", section: "project"}, // Type is changed to 'text' if 'building_code' is equal to 'Other (please specify)'
  
  // {name: "additional-header", type: "header", label: "Additional Information", section: "additional"},
  {name: "budget_select", required: false, type: "select", label: "Do you have an earmarked budget for this work?", placeholder: "Please select an amount...", options: budgetValues, size: "half", section: "additional"},
  {name: "timeframe_select", required: false, type: "select", label: "My timeline for placing an order is...", placeholder: "Please select a timeframe...", options: placeOrderValues, size: "half", section: "additional"},

  {name: "special_requests", required: false, type: "checkbox", label: "I have a special request...", options: specialRequestsValues, size: "half", section: "additional"},
  {name: "looking_for", required: false, type: "radio", label: "I am looking for...", options: lookingForValues, size: "half", section: "additional"},
  
  {name: "message", required: false, type: "textarea", label: "Message", placeholder: "Any last notes or special requests...", size: "half", section: "additional"},


  { name: "marketing_opt_ins", type: "opt_in_group", label: "Want to stay in touch?",
    fields: [
      { name: "email_opt_in", label: "Get news & offers on our mailing list", options: ["Yes"] },
      { name: "sms_opt_in", label: "Stay in touch over text", options: ["Yes"] }
    ],
    size: "half", section: "additional"
  },

  // {name: "email_opt_in", required: false, type: "checkbox", label: "Email me with news and offers", options:  ["Yes"], size: "half", section: "additional"},
  // {name: "sms_opt_in", required: false, type: "checkbox", label: "Text me with news and offers", options:  ["Yes"], size: "half", section: "additional"},
]


